import { incomes } from './service';
import { Effect } from 'umi';
import { Reducer } from '@@/plugin-dva/connect';

export interface WeiBoLinkType{
  data: []
}


export interface ModelType {
  namespace: string;
  state: WeiBoLinkType;
  effects: {
    fetch: Effect;
  };
  reducers: {
    save: Reducer;
  };
}

const Model: ModelType = {
  namespace: 'weibo',

  state: {
    data: []
  },

  effects: {
    *fetch( {} ,{ call, put }) {
      const response = yield call(incomes);
      yield put({
        type: 'save',
        payload: response,
      });
    }
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload.data
      };
    }
  },
};

export default Model;
